module.exports = __webpack_public_path__ + "img/food-2.ab9e78f2.jpg";